/**
 * German — every string this portal says.
 *
 * Translated from the Slovenian original, which is the source of truth for the
 * vocabulary: the words for a stamp, a shift, a change to one and a decision about
 * leave are the words the rest of this product uses, and a second wording would be a
 * second feature as far as anybody comparing two screens is concerned.
 */
export default {
    app: {
        name: "Mitarbeiter",
    },
    errors: {
        conflict: "Der Eintrag ist bereits vergeben oder vorhanden",
        generic_error: "Es ist ein Fehler aufgetreten",
        invalid_data: "Ungültige Daten",
        module_not_licensed: "Dieses Modul ist für dieses Hotel nicht freigeschaltet",
        not_found: "Nicht gefunden",
        on_add: "Fehler beim Hinzufügen",
        on_edit: "Fehler beim Bearbeiten",
        on_load: "Fehler beim Laden",
        operation_in_progress: "Dieser Stempel wird gerade gespeichert. Drück nicht noch einmal — gleich ist er zu sehen.",
        operation_mismatch: "Der Bildschirm ist veraltet. Lade die Seite neu und versuch es noch einmal.",
        session_expired: "Die Sitzung ist abgelaufen. Meld dich neu an — es wurde nichts gemacht.",
        staff_break_recording_off: "Das Haus erfasst keine Pausen.",
        staff_not_employed: "Für diesen Tag hast du kein gültiges Personalstammblatt, deshalb kann der Stempel nicht gespeichert werden. Sag es deiner Führungskraft oder der Personalabteilung.",
        staff_time_busy: "Der Stempel wird gerade gespeichert. Versuch es gleich noch einmal.",
        staff_time_month_closed: "Dieser Monat ist abgeschlossen und kann nicht mehr geändert werden. Wenn etwas nicht stimmt, wende dich an deine Führungskraft — wieder öffnen kann ihn nur die Personalabteilung.",
        staff_time_out_of_range: "Die Stempelzeit liegt außerhalb des erlaubten Zeitfensters.",
        staff_time_sequence: "Diese Reihenfolge der Stempel ist nicht möglich (z. B. Kommen an einem Tag, der schon offen ist).",
        unauthorized: "Dafür hast du keine Berechtigung",
    },
    general: {
        hint: 'Hinweis',
        cancel: "Abbrechen",
        hide_password: "Passwort verbergen",
        save: "Speichern",
        show_password: "Passwort anzeigen",
    },
    home: {
        needs_you: "Wartet auf deine Antwort",
        no_shift_today: "Für heute ist keine Schicht veröffentlicht.",
        open_clock: "Alle Stempel",
        waiting_on_others: "Wartet auf die Antwort des Hauses",
    },
    license: {
        contact: "Wende dich für die Freischaltung an den Systemadministrator. Die Daten des Hauses bleiben unberührt.",
        lead: "Das Modul »Mitarbeiter und Zeit« gehört nicht zum Abonnement dieses Hauses, deshalb kann dieses Portal nichts anzeigen.",
        switch_account: "Mit einem anderen Konto anmelden",
        title: "Dieser Dienst ist nicht freigeschaltet",
    },
    login: {
        demo_signing_in: "Anmeldung …",
        demo_failed: "Diese Rolle gibt es auf diesem Server nicht.",
        failed: "Falscher Benutzername oder falsches Passwort",
        password: "Passwort",
        remember: "Angemeldet bleiben",
        remember_hint: "Auf deinem eigenen Telefon. Auf einem fremden meld dich lieber nicht dauerhaft an.",
        same_account: "Meld dich mit demselben Benutzernamen und Passwort an wie im PMS. Ein Passwort kann hier nicht zurückgesetzt werden — wende dich dafür an den Administrator.",
        submit: "Anmelden",
        subtitle: "Meine Uhr, mein Dienstplan, mein Urlaub und meine Dokumente.",
        title: "Anmeldung",
        username: "Benutzername",
    },
    nav: {
        account: "Konto",
        clock: "Uhr",
        documents: "Dokumente",
        home: "Start",
        language: "Sprache",
        language_de: "Deutsch",
        language_en: "English",
        language_hr: "Hrvatski",
        language_hu: "Magyar",
        language_it: "Italiano",
        language_sl: "Slovenščina",
        leave: "Urlaub",
        logout: "Abmelden",
        profile: "Mein Profil",
        rota: "Dienstplan",
        theme: "Darstellung",
        theme_dark: "Dunkel",
        theme_light: "Hell",
        theme_system: "System",
    },
    notifications: {
        channel_email: "E-Mail",
        channel_email_hint: "Braucht deine E-Mail-Adresse.",
        channel_messaging: "Messenger-Apps",
        channel_messaging_hint: "Braucht deine WhatsApp-Nummer oder ein mit dir verknüpftes Viber.",
        channel_push: "App auf dem Telefon",
        channel_push_hint: "Braucht ein Diensttelefon oder eine Uhr, die mit dir verknüpft ist.",
        channel_sms: "SMS",
        channel_sms_hint: "Braucht deine Telefonnummer.",
    },
    profile: {
        account_hint: "Wer du im System bist.",
        account_managed_elsewhere: "Name, Benutzername und Passwort pflegt der Systemadministrator. Hier lassen sie sich nicht ändern.",
        account_title: "Konto",
        card_hint: "Was das Haus über deine Arbeit festgehalten hat.",
        card_read_only: "Das Stammblatt pflegt die Personalabteilung. Wenn etwas nicht stimmt, sag es ihr — eine Korrektur ist ein neues Stammblatt und kein verbessertes altes.",
        card_title: "Mein Personalstammblatt",
        channel_unavailable: "Diesen Weg hat das Haus (noch) nicht eingerichtet.",
        channels: "Wege der Benachrichtigung",
        channels_hint: "Nichts ausgewählt heißt alle Wege, die das Haus hat. Ein grauer Weg heißt, dass das Haus ihn nicht eingerichtet hat.",
        contact_hint: "Wohin das Haus die Nachricht zum Dienstplan schicken soll. Diese Angaben gehören dir und du pflegst sie selbst.",
        contact_title: "Meine Angaben für Benachrichtigungen",
        department: "Abteilung",
        email: "E-Mail",
        email_hint: "Hierher kommt die Nachricht über einen veröffentlichten Dienstplan und über eine geänderte Schicht.",
        employee_no: "Personalnummer",
        engagement: "Rechtsgrundlage",
        hours_per_week: "{hours} Stunden pro Woche",
        language_hint: "Gilt für dieses Gerät. Die Sprache im Konto stellt die Personalabteilung ein; sie bestimmt, in welcher Sprache sich das Portal beim ersten Mal öffnet.",
        manager: "Vorgesetzter",
        name: "Name",
        no_card: "Für heute gibt es kein gültiges Stammblatt.",
        no_card_hint: "Das ist am ersten Tag oder zwischen den Saisonen normal. Wenn du arbeitest, sag es der Personalabteilung.",
        period: "Zeitraum",
        period_from: "ab {date}",
        phone: "Telefon",
        phone_hint: "In internationaler Form: +38641123456.",
        phone_invalid: "Die Telefonnummer muss die Form +386… haben (8 bis 15 Ziffern).",
        position: "Stelle",
        property: "Haus",
        saved: "Gespeichert.",
        time_record: "Arbeitszeiterfassung",
        time_record_not_required: "Nicht verpflichtend",
        username: "Benutzername",
        weekly_obligation: "Wöchentliche Sollarbeitszeit",
        work_pattern: "Verteilung auf die Tage",
        working_time: "Arbeitszeit",
    },
    staff: {
        acknowledge: "Zur Kenntnis genommen",
        acknowledge_failed: "Die Bestätigung konnte nicht gespeichert werden.",
        acknowledge_hint: "Mit der Bestätigung wird festgehalten, dass du die Änderung gesehen hast, und wann. Solange du nicht bestätigst, sieht die Dienstplanung, dass du es noch nicht weißt.",
        acknowledged: "Empfang bestätigt",
        basis_agency_worker: "Leiharbeiter",
        basis_copyright_contract: "Urhebervertrag",
        basis_employment_contract: "Arbeitsvertrag",
        basis_other: "Andere Rechtsgrundlage",
        basis_pensioner_temporary: "Zeitweise Arbeit eines Rentners",
        basis_self_employed: "Selbstständiger Auftragnehmer",
        basis_service_contract: "Werkvertrag",
        basis_short_term_family_work: "Kurzzeitige Familienarbeit",
        basis_student_work: "Studentische Arbeit",
        basis_traineeship: "Praktikum oder Lehre",
        break_of: "Pause {minutes}",
        change_changed_at: "Geändert {at}",
        change_moved: "Von {previous} auf {current}",
        change_reason_line: "Grund: {reason}",
        change_withdrawn: "Die Schicht ist abgesagt (sie war {previous})",
        day_friday: "Fr",
        day_monday: "Mo",
        day_saturday: "Sa",
        day_sunday: "So",
        day_thursday: "Do",
        day_tuesday: "Di",
        day_wednesday: "Mi",
        decline: "Ich kann nicht",
        decline_failed: "Die Antwort konnte nicht gespeichert werden.",
        decline_hint: "Die Dienstplanung sieht, dass du nicht kannst, und sucht Ersatz. Die Änderung bleibt auf der Liste, bis das geregelt ist.",
        decline_note: "Warum kannst du nicht? (freiwillig)",
        decline_send: "Senden",
        decline_title: "Ich kann nicht arbeiten",
        declined: "Festgehalten: du kannst nicht.",
        duration_fixed_term: "Befristet",
        duration_indefinite: "Unbefristet",
        exempt_managing_person: "Leitende Person",
        exempt_other: "Anderer Grund",
        free_day: "Frei",
        load_failed: "Die Daten konnten nicht gelesen werden.",
        my_changes_title: "Änderungen, die du noch nicht bestätigt hast: {count}",
        my_pending_title: "Anträge, die auf eine Entscheidung warten: {count}",
        my_rota: "Mein Dienstplan",
        my_rota_empty: "Diese Woche hast du keine Schicht eingeteilt.",
        my_rota_empty_hint: "Was du hier siehst, ist nur das Veröffentlichte. Entwürfe der Dienstplanung werden nicht gezeigt — solange eine Woche nicht veröffentlicht ist, ist sie kein Versprechen.",
        next_week: "Nächste Woche",
        no_swap_hint: "Schichttausch mit einem Kollegen und Bitten um Vertretung gibt es in diesem Portal nicht. Wenn du eine Schicht nicht arbeiten kannst, drück oben bei der Änderung auf »Ich kann nicht« — deine Führungskraft sieht es sofort, mitsamt dem Grund. Für eine geplante Abwesenheit stell einen Urlaubsantrag.",
        previous_week: "Vorige Woche",
        record_clock: "Stempel",
        record_manual: "Manuelle Eingabe",
        record_pattern: "Arbeitsmuster",
        record_schedule: "Dienstplan",
        state_cancelled: "Abgesagt",
        state_draft: "Entwurf",
        state_published: "Veröffentlicht",
        this_week: "Diese Woche",
        time_full: "Vollzeit",
        time_part: "Teilzeit",
        today: "Heute",
        try_again: "Noch einmal versuchen",
        unit_hours: "Std.",
        unit_minutes: "Min.",
    },
    staff_absence: {
        days_recorded: "Erfasste Tage: {count}",
        decided_by_other: "Über den Antrag entscheidet jemand anderes — deinen eigenen kannst du nicht genehmigen.",
        from: "Von",
        kind: "Art",
        kind_business_trip: "Dienstreise",
        kind_holiday: "Feiertag",
        kind_other: "Sonstiges",
        kind_sick_leave: "Krankheit",
        kind_training: "Schulung",
        kind_unexcused: "Unentschuldigte Abwesenheit",
        kind_vacation: "Urlaub",
        my_absences: "Meine Abwesenheiten",
        my_absences_hint: "Deine Anträge und die Entscheidungen darüber. Abgelehnte bleiben sichtbar — eine Ablehnung, die verschwindet, ist eine Ablehnung, die es nicht gab.",
        no_my_requests: "Du hast keine Anträge auf Abwesenheit.",
        note: "Bemerkung",
        other_kinds_hint: "Beantragen kannst du nur Urlaub. Krankheit meldest du deiner Führungskraft, die sie in die Erfassung einträgt; der Feiertag kommt aus dem Kalender des Hauses; Schulung und Dienstreise ordnet der Arbeitgeber an. All das erscheint in deiner Erfassung, sobald es eingetragen ist.",
        other_kinds_title: "Andere Abwesenheiten",
        range_backwards: "Das Ende kann nicht vor dem Anfang liegen.",
        range_too_long: "Ein Antrag darf höchstens {days} Tage umfassen. Eine längere Abwesenheit trägt die Führungskraft ein.",
        request_hint: "Für dich selbst kannst du Urlaub beantragen. Krankheit wird gemeldet und erfasst, der Feiertag kommt aus dem Kalender, Schulung und Dienstreise trägt die Führungskraft ein.",
        request_leave: "Urlaub beantragen",
        request_sent: "Der Antrag ist zur Entscheidung abgeschickt.",
        send_request: "Antrag senden",
        source_calendar: "Feiertagskalender",
        source_manager: "Eintrag der Führungskraft",
        source_request: "Antrag",
        state_approved: "Genehmigt",
        state_rejected: "Abgelehnt",
        state_requested: "Beantragt",
        state_withdrawn: "Zurückgezogen",
        to: "Bis",
        total_absence: "Abwesenheit",
        withdraw: "Zurückziehen",
        withdrawn: "Der Antrag ist zurückgezogen.",
    },
    staff_document: {
        download: "Herunterladen",
        expired_on: "Abgelaufen {date}",
        expires_on: "Gültig bis {date}",
        kind_aneks: "Nachtrag",
        kind_drugo: "Sonstiges",
        kind_m1: "Formular M-1",
        kind_nda: "Verschwiegenheitserklärung",
        kind_odlok: "Bescheid",
        kind_pogodba: "Arbeitsvertrag",
        my_documents: "Meine Dokumente",
        my_documents_hint: "Was das Haus zu dir abgelegt hat. Du liest und lädst herunter; abgelegt wird vom Haus.",
        no_my_documents: "Für dich ist noch kein Dokument abgelegt.",
        read_only_hint: "Dokumente können hier nicht hinzugefügt oder gelöscht werden — die Akte ist der Nachweis des Arbeitgebers. Eine Empfangsbestätigung hat nur der Urlaubsbescheid.",
    },
    staff_month: {
        badge_closed: "Abgeschlossen",
    },
    staff_time: {
        break_counts_hint: "Die Pause zählt zur Arbeitszeit und wird nicht abgezogen.",
        break_short: "Pause {minutes}",
        correction_approved: "Genehmigt",
        correction_date: "Datum",
        correction_decided_by_other: "Über den Antrag entscheidet jemand anderes — deinen eigenen kannst du nicht genehmigen.",
        correction_hint: "Beantragen kannst du selbst; entscheiden tut jemand anderes.",
        correction_kind: "Art des Stempels",
        correction_mode_existing: "Korrektur eines vorhandenen Stempels",
        correction_mode_missing: "Fehlender Stempel",
        correction_no_stamps: "Dieser Tag hat keinen Stempel, der sich korrigieren ließe.",
        correction_reason: "Grund",
        correction_rejected: "Abgelehnt",
        correction_requested: "Beantragt",
        correction_send: "Antrag senden",
        correction_sent: "Der Antrag ist zur Entscheidung abgeschickt.",
        correction_time: "Uhrzeit",
        correction_what: "Was du korrigierst",
        correction_which_stamp: "Welcher Stempel",
        day_open: "Der Tag ist nicht abgeschlossen — es ist kein Gehen erfasst.",
        decision_reason: "Grund: {reason}",
        excess_pending: "Überschuss — wartet auf Zuordnung",
        first_in: "Kommen {at}",
        kind_break_end: "Ende der Pause",
        kind_break_start: "Pause",
        kind_clock_in: "Kommen",
        kind_clock_out: "Gehen",
        last_out: "Gehen {at}",
        month_pdf: "Monatsauszug (PDF)",
        my_corrections: "Meine Korrekturanträge",
        my_record: "Meine Erfassung",
        my_time: "Meine Uhr",
        next_month: "Nächster Monat",
        no_days: "In diesem Zeitraum sind keine Tage erfasst.",
        of_which_break: "davon Pause {minutes}",
        open: "Nicht abgeschlossen",
        period_month: "Monat",
        period_week: "Woche",
        previous_month: "Voriger Monat",
        queued: "Wartet auf Verbindung: {count}",
        refused: "Der Stempel wurde nicht angenommen.",
        not_recorded: "Der Stempel wurde nicht erfasst: {reason}",
        request_correction: "Korrektur beantragen",
        stamped: "Erfasst: {kind}",
        this_month: "Dieser Monat",
        today_total: "Heute",
        total_balance: "Saldo",
        total_break: "Pause",
        total_expected: "Sollarbeitszeit",
        total_worked: "Arbeit",
    },
    staff_vacation: {
        acknowledge: "Zur Kenntnis genommen",
        acknowledge_hint: "Du bestätigst den ERHALT des Bescheids, nicht das Einverständnis mit der Zahl der Tage.",
        acknowledged: "Bestätigt",
        acknowledged_toast: "Der Erhalt des Bescheids ist festgehalten.",
        available: "Verfügbar",
        bucket_current: "Neu",
        bucket_old: "Alt",
        current_leave: "Jahresurlaub {year}",
        days_count: "{count} Tage",
        decision_for_year: "Bescheid für das Jahr {year}",
        decision_total: "Zugeteilt: {days}",
        entitled: "Zugeteilt",
        expired_days: "Verfallen {days} — die Frist war {date}.",
        issued_at: "Ausgestellt von: {who}, {at}",
        my_balance: "Mein Urlaub",
        my_decisions: "Meine Bescheide",
        my_decisions_hint: "Die Bescheide über die Zuteilung des Jahresurlaubs, die das Haus dir ausgestellt hat.",
        next_year: "Nächstes Jahr",
        no_balance: "Für dieses Jahr gibt es keine Urlaubsangabe.",
        no_balance_hint: "Ein Saldo entsteht, wenn ein Bescheid ausgestellt ist und die Person einen gültigen Beschäftigungszeitraum hat.",
        no_my_decisions: "Für dich ist noch kein Bescheid ausgestellt.",
        no_usage: "In diesem Jahr ist kein Urlaub als genommen erfasst.",
        not_acknowledged: "Nicht bestätigt",
        not_issued_hint: "Der Bescheid für dieses Jahr ist noch nicht ausgestellt.",
        of_which_pending: "Davon wartet auf Entscheidung: {days}",
        of_which_used: "Davon genommen: {days}",
        old_leave: "Alter Urlaub ({year})",
        over_remaining: "Der Antrag übersteigt die verfügbaren {days}. Die Entscheidung liegt trotzdem beim Haus.",
        part_base: "Grundlage",
        part_children: "Kinder",
        part_education: "Ausbildung",
        part_full_year: "Gesamt (ganzes Jahr)",
        part_responsibility: "Verantwortungsvolle Stelle",
        part_special: "Besondere Kategorie",
        part_tenure: "Betriebszugehörigkeit",
        pdf: "PDF",
        pending: "In Entscheidung",
        previous_year: "Voriges Jahr",
        requested_days: "Beantragte Arbeitstage: {days}",
        still_days: "noch {days}",
        still_of: "noch {left} von {total}",
        this_year: "Dieses Jahr",
        usage_history: "Verlauf der Nutzung",
        use_by: "Nimm ihn bis {date}.",
        used: "Genommen",
    },
    success: {
        add: "Erfolgreich hinzugefügt",
        edit: "Erfolgreich aktualisiert",
    },
    validation: {
        email: "Ungültige E-Mail-Adresse",
        required: "Dieses Feld ist ein Pflichtfeld",
    },
}
